/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { feedTranslationSchema } from '../../challenges/schemas/feed-translation-schema';

const titleSlideSchema = z.object({ type: z.literal('title') });

export const feedSourceSchema = z.object({
  collectionTitle: z.string(),
  parentTitle: z.string().nullable(),
  year: z.number().nullable(),
});

export type IFeedSource = z.infer<typeof feedSourceSchema>;

const videoSlideSchema = z.object({
  type: z.literal('video'),
  videoUrl: z.string().url(),
  transcript: z.string().nullable().optional(),
  source: feedSourceSchema.optional(),
});

export const feedSlideSchema = z.discriminatedUnion('type', [titleSlideSchema, videoSlideSchema]);

export type IFeedSlide = z.infer<typeof feedSlideSchema>;

export const feedItemSchema = z.object({
  id: z.number().int(),
  slug: z.string(),
  title: z.string(),
  targetContent: z.string(),
  type: z.enum(['Chunk', 'Word', 'Grammar']),
  cefrLevel: z.string(),
  definition: z.string(),
  usageNote: z.string(),
  examples: z.array(z.object({ id: z.number(), text: z.string() })),
  sourceRef: z.string(),
  slides: z.array(feedSlideSchema),
  titleAudioUrl: z.string().nullable().optional(),
  definitionAudioUrl: z.string().nullable().optional(),
  usageNotesAudioUrl: z.string().nullable().optional(),
  translation: feedTranslationSchema.optional(),
  source: feedSourceSchema.optional(),
});

export type IFeedItem = z.infer<typeof feedItemSchema>;

export interface IGetFeedRequest {
  cursor?: string;
}
